import { Controller } from "@hotwired/stimulus"

const FLIGHT_MS = 900

const visibleDestination = kind =>
  [...document.querySelectorAll(`[data-flight-destination="${kind}"]`)].find(element => element.getClientRects().length > 0)

const centerOf = element => {
  const { left, top, width, height } = element.getBoundingClientRect()
  return { x: left + width / 2, y: top + height / 2 }
}

const fly = (copy, from, to) => {
  const flight = copy.animate([
    { transform: "translate(0, 0) scale(1)", opacity: 1, easing: "ease-out" },
    { transform: "translate(0, -16px) scale(1.6)", opacity: 1, offset: 0.25, easing: "ease-in" },
    { transform: `translate(${to.x - from.x}px, ${to.y - from.y}px) scale(0.5)`, opacity: 0.3 },
  ], { duration: FLIGHT_MS, fill: "forwards" })
  flight.onfinish = () => copy.remove()
}

export default class extends Controller {
  static values = { list: String }
  static classes = ["icon"]

  launch() {
    if (this.launched || matchMedia("(prefers-reduced-motion: reduce)").matches) return

    const destination = visibleDestination(this.listValue) ?? visibleDestination("user")
    if (!destination) return

    this.launched = true
    const icon = this.element.querySelector("svg")
    const copy = this.#filledCopyOf(icon)
    document.body.append(copy)
    fly(copy, centerOf(icon), centerOf(destination))
  }

  #filledCopyOf(icon) {
    const { left, top, width, height } = icon.getBoundingClientRect()
    const copy = icon.cloneNode(true)
    copy.classList.add(...this.iconClasses)
    copy.style.fill = "currentColor"
    copy.setAttribute("aria-hidden", "true")
    copy.dataset.turboTemporary = ""
    Object.assign(copy.style, {
      position: "fixed",
      left: `${left}px`,
      top: `${top}px`,
      width: `${width}px`,
      height: `${height}px`,
      pointerEvents: "none",
      zIndex: "9999",
    })
    return copy
  }
}
